// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1179":"d614ec48","2200":"d614ec48","5113":"d614ec48","7489":"d614ec48","7667":"d614ec48"}[chunkId] + ".chunk.css";
};